import React, { createContext, FC, PropsWithChildren, useContext, useMemo } from 'react';
import { useManageReadyPcsV2, UseManageReadyPcsV2Params, UseManageReadyPcsV2Return } from '@components/common/ReadyPcsV2/hooks/useManageReadyPcsV2';

const ReadyPcsV2Context = createContext<UseManageReadyPcsV2Return | null>(null);

export const useReadyPcsV2ContextOptional = () => useContext(ReadyPcsV2Context);

interface ReadyPcsV2ProviderProps extends PropsWithChildren, UseManageReadyPcsV2Params {}

export const ReadyPcsV2Provider: FC<ReadyPcsV2ProviderProps> = ({ children, ...hookParams }) => {
  const value = useManageReadyPcsV2(hookParams);

  const memoizedValue = useMemo(() => value, [
    value.targetQuantity,
    value.producedQuantity,
    value.shouldDisplayRightPart,
    value.amountOfBullets,
    value.shouldRenderBullets,
    value.progressFlex,
    value.remainingFlex,
    value.timelineBackgroundColor,
    value.finishedBulletColor,
    value.isCalculationComplete,
    value.hasOverlap,
    value.overlappedBulletColor,
  ]);

  return <ReadyPcsV2Context.Provider value={memoizedValue}>{children}</ReadyPcsV2Context.Provider>;
};
